// extracted by mini-css-extract-plugin
module.exports = {"notification":"site-notification_notification__VPGgg","error":"site-notification_error___o8_J","success":"site-notification_success__PehYx"};